import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { NavController } from '@ionic/angular';
import { Subject } from 'rxjs';

import { SummaryPriceDefault } from '../../../../shared/models/Constants';
import { ISummaryPrice } from '../../models/productos';

@Component({
  selector: 'total-products',
  templateUrl: './total-products.component.html',
  styleUrls: ['./total-products.component.scss'],
})
export class TotalProductsComponent implements OnInit, OnDestroy {

  @Input() summaryPrice: ISummaryPrice = SummaryPriceDefault;

  public classCenterStart = 'ion-align-self-center';
  public sizeButton = window.innerWidth > 340 ? 'default' : 'small';

  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private nav: NavController
  ) { }

  ngOnInit() {
    if (Capacitor.getPlatform() === 'android') {
      this.classCenterStart = 'ion-align-self-center'
    } else if (Capacitor.getPlatform() === 'ios') {
      this.classCenterStart = 'ion-align-self-start'
    }
  }

  ngOnDestroy() {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  public onBuy() {
    this.nav.navigateForward(['/Carrito'], { animated: true, animationDirection: 'forward' })
  }

}
